module.exports = __webpack_public_path__ + "img/instore.ec23089c.png";